import { EPaymentGroup } from '@model';
import { isObjectEmpty } from '@utils/general';

import { ILastOrder } from '../../../model';

import {
  EFreeDeliveryOptionFlag,
  ILastOrderValidatedCart,
  ILastOrderValidatedCartResponse,
  IValidateLastOrderCartRequest,
} from './model';
import { isLastOrderValidatedCartResponse, isValidateLastOrderCartRequest } from './model.guard';

export const mappingFunctionCheckout = (result: ILastOrderValidatedCartResponse): ILastOrderValidatedCart | null => {
  if (!result || isObjectEmpty(result) || !isLastOrderValidatedCartResponse(result)) {
    return null;
  }

  const prices = result.orderAsLastTimeValidateCart.data.cart.pricesSummary;

  return {
    prices: {
      paymentPrice: prices.pricePayment,
      deliveryPrice: prices.priceDelivery,
      totalPrice: prices.pricePayment + prices.priceDelivery + prices.priceItemSummary,
    },
    paymentInfo: {
      ...result.orderAsLastTimeValidateCart.data.paymentInfo,
      paymentGroups: result.orderAsLastTimeValidateCart.data.paymentInfo.paymentGroups as EPaymentGroup[],
    },
    freeDeliveryOptionFlag: result.orderAsLastTimeValidateCart.data.freeDeliveryOptionFlag as EFreeDeliveryOptionFlag,
    valid: result.orderAsLastTimeValidateCart.data.valid,
  };
};

export const mapToCheckoutRequest = (checkoutLastOrder?: ILastOrder): IValidateLastOrderCartRequest | null => {
  if (!checkoutLastOrder) {
    return null;
  }
  const { orderPricesSummary, ...request } = checkoutLastOrder;
  return isValidateLastOrderCartRequest(request) ? request : null;
};
